import GetRequest from './GetRequest'
import PostRequest from './PostRequest'
import type { PostRequestOptions } from './PostRequest'
import DeleteRequest from './DeleteRequest'
import PatchRequest from './PatchRequest'
import PutRequest from './PutRequest'

export default {
  get: async <R>(
    url: string,
    params?: any | undefined,
    headers?: any | undefined,
    responseType?: any | undefined,
    timeout?: number
  ) => {
    const getRequest = new GetRequest(url, params, headers, responseType, timeout)
    return getRequest.run<R>()
  },
  post: async <R>(url: string, body: unknown, options?: PostRequestOptions) => {
    const postRequest = new PostRequest(url, body, options)
    return postRequest.run<R>()
  },
  put: async <R>(
    url: string,
    body: any,
    headers?: Record<string, string> | undefined,
    timeout?: number
  ) => {
    const putRequest = new PutRequest(url, body, headers, timeout)
    return putRequest.run<R>()
  },
  patch: async <R>(
    url: string,
    body: any,
    headers?: Record<string, string> | undefined,
    params?: any | undefined,
    timeout?: number
  ) => {
    const patchRequest = new PatchRequest(url, body, headers, params, timeout)
    return patchRequest.run<R>()
  },
  delete: async (url: string, headers?: any, timeout?: number) => {
    const deleteRequest = new DeleteRequest(url, headers, timeout)
    return deleteRequest.run()
  }
}
